import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class GlobalSetting extends Component {

  constructor(props){
    super(props);
    this.state={
      settingId: this.props.setting.id,
      settingName: this.props.setting.name,
      settingValue: this.props.setting.value,
      errorMsg: '',
    }
    this.onInputChange = this.onInputChange.bind(this);
    this.updateGlobalSetting = this.updateGlobalSetting.bind(this);
  }

  onInputChange = evt => {
    this.setState({[evt.target.name]: evt.target.value})
  };

  updateGlobalSetting(e) {
    e.preventDefault();
    let validationString = this.props.validationString
    //let settingValueCheck = this.state.settingValue.startsWith(validationString)
    this.setState({errorMsg: ''})

    let setVal = this.state.settingValue

    if(this.state.settingValue !== ''){
      if(setVal.includes("m.centa.org/pwa")){
        this.setState({errorMsg: 'If the link is within MyCenta portal then it should not be full link'})
        return
      }

      if(!setVal.includes("pwa/app")){
        if(!(setVal.startsWith(validationString))){
          this.setState({errorMsg: 'Any External Link should start with http or https'})
          return
        }
      }
    } 
    

    let value = {
      'global_value': this.state.settingValue
    }
    let globalId = this.state.settingId
    api.updateGlobalSetting(this.props.user.accessToken, globalId,  value)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({errorMsg: result.data})
          }
          else{
            this.setState({errorMsg: result.data})
          }
        })
  }

  render() {
    return(
      <div>
        <GridCell span="12">
        <Grid>
          <GridCell span="1"><Typography use="content"> Name </Typography></GridCell>
          <GridCell span="11"><Typography use="subtitle2"> {this.state.settingName} </Typography></GridCell>
          <GridCell span="10">
            <TextField fullwidth label="Link" autoComplete="off" name="settingValue" onChange={this.onInputChange} value={this.state.settingValue} style={{ height: '140%' }}/>
          </GridCell>
            <GridCell span="2"><Button onClick={this.updateGlobalSetting} style={{ paddingTop: '20px' }}>Update</Button></GridCell>
        </Grid>
        </GridCell>
        <StatusMessage error_msg = {this.state.errorMsg} />
      </div>
      );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSetting);


// WEBPACK FOOTER //
// ./src/views/admin/GlobalSetting.jsx